import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import MyTextField from "../../components/MyTextField";
import { setOrganizationOfficeNewName } from "../../api/s10OrganizationApi";
import { Office } from "../../interfaces/s10Corporation.interface";
import MySnackbar from "../../components/MySnackbar";



interface EditNodeModalProps {
    nodeData: Office | null;
    onCancel: () => void;
    setEditedNodeData: (data: Office) => void,
}

const EditNodeModal = ({nodeData, onCancel, setEditedNodeData}: EditNodeModalProps) => {
    const [officeName, setOfficeName] = useState<string>(nodeData?.Name || "");
    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<string>('');

    const handleSaveNewOffice = async () => {
        if (!nodeData?.Id) {
            return;
        }
        if (nodeData.Name === officeName || !officeName) {
            setError("El nuevo nombre debe ser diferente al anterior y diferente a vacío.");
            return;
        }
        const result = await setOrganizationOfficeNewName(nodeData?.Id, officeName);
        if (result?.data?.Type !== 0) {
            setError(result?.data?.Message || "Ocurrió un error")
            return;
        }
        console.log(result)
        setEditedNodeData({
            ...nodeData,
            Name: officeName,
        });
        setSuccess("Nombre actualizado.")
    }
    

    return (<Dialog
        open={true}
        aria-labelledby="responsive-dialog-title"
        style={{width: "100%"}}
    >
        <DialogTitle
            id="responsive-dialog-title" 
            style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
            variant="h5"
        >
            Editar gerencia
        </DialogTitle>
        <DialogContent style={{width: "25rem", textAlign: "center"}}>
            <Grid container spacing="1.5rem">
                <Grid item xs={12} style={{maxWidth: "25rem"}}>
                    <FormControl error={!!error} fullWidth >
                        <MyTextField
                            style={{width: "100%"}} 
                            label="Nombre"
                            onChange={({target}) => setOfficeName(target.value)}
                            value={officeName}
                        />
                        {/* {error && <FormHelperText>{error}</FormHelperText>} */}
                    </FormControl>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid 
                container 
                direction="row"
                justifyContent="space-between"
                margin={"0.5rem 1rem 2rem 1rem"}
            >
                <Grid item >
                    <Button
                        variant="outlined" 
                        style={{width: "8rem"}}
                        startIcon={<CloseIcon style={{height: "1rem"}} />}
                        onClick={onCancel}
                    >
                        Cancelar
                    </Button>
                </Grid>
                <Grid item textAlign={"right"} marginLeft={"1rem"}>
                    <Button 
                        variant="contained" 
                        color={"primary"}
                        style={{width: "8rem"}}
                        startIcon={<CheckIcon style={{height: "1rem"}} />}
                        onClick={handleSaveNewOffice}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
        {success && <MySnackbar
            severity="success"
            msg={success}
            open={true}
            onClose={() => {
                setSuccess("");
                onCancel()
            }}
            autoHideDuration={1500}
        />}
        {error && <MySnackbar
            severity="error"
            msg={error}
            open={true}
            onClose={() => setError("")}
        />}
    </Dialog>)
}

export default EditNodeModal